<template>
  <div class="table-btnGroup-ctrl">
    <el-row>
      <el-button type="primary" size="mini" @click="onAdd">添加</el-button>
      <el-button type="primary" plain size="mini" @click="onBlankName">银行名称管理</el-button>
      <el-button size="mini" @click="onExport">导出</el-button>
    </el-row>
  </div>
</template>

<script>
    export default {
        name: "dataTableCtrl",
        components: {},
        data() {
            return {}
        },
        computed: {},
        mounted() {
        },
        methods: {
          onAdd(){
            this.$emit('add', this.filter);
          },
          onBlankName(){
            this.$emit('blankName', this.filter);
          },
          onExport(){
            this.$emit('export', this.filter);
          },
        }
    }
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .table-btnGroup-ctrl {
    padding: 20px 20px 10px 20px;
    button {
      margin-left: 0;
      margin-right: 5px;
    }
  }
</style>
